import { render, staticRenderFns } from "./SecretForm.vue?vue&type=template&id=ed4a599e"
import script from "./SecretForm.vue?vue&type=script&lang=js"
export * from "./SecretForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports